import { Link } from "react-router-dom";
import { footerGroups, siteInfo } from "@/mocks/site";
import SubscribeForm from "./SubscribeForm";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-content mx-auto px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-line text-xl"></i>
              </span>
              <span className="text-xl font-script tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90 max-w-md">
              轻松向网络吃瓜社区。热帖专区、高赞神回复与加精置顶热评一条龙，帮你快速 get
              今日最火的那件事。
            </p>
            <div className="mt-6 max-w-md">
              <p className="text-sm font-medium text-background-50 mb-3">订阅吃瓜日报</p>
              <SubscribeForm variant="panel" />
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-medium text-background-50 mb-4">
                  <a href="#top" className="hover:text-primary-200 transition-colors">
                    {group.title}
                  </a>
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-200/85 hover:text-primary-200 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="col-span-2 sm:col-span-3">
              <h4 className="text-sm font-medium text-background-50 mb-4">
                <a href="mailto:hi@heiliaowangshe.example" className="hover:text-primary-200 transition-colors">
                  联系与投稿
                </a>
              </h4>
              <p className="text-sm text-background-200/85 leading-relaxed">
                投稿或内容反馈，欢迎发送邮件至
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="ml-1 text-primary-200 hover:text-primary-100 underline underline-offset-4 transition-colors"
                >
                  {siteInfo.email}
                </a>
                ，我们会在三个工作日内回复。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} {siteInfo.name} · 站内内容均为社区创作与匿名分享，不针对任何真实人物
          </p>
          <p className="text-xs text-background-200/70">
            自 {siteInfo.since} 年运营 · 轻松围观，理性吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}